<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);
</script>
<template>
  <div class="active">
    <div class="title">
      <h2>
        {{ info.language_list.events }}
        <i class="iconfont icon-fanye"></i>
      </h2>
      <div>{{ info.language_list.now }}</div>
    </div>
    <div
      class="active-banner-box"
      v-if="info.activity !== ''">
      <ul class="active-banner">
        <li
          v-for="(item, index) in info.activity"
          :key="index">
          <div class="active-item">
            <img
              :src="item.img_url"
              alt="" />
            <div class="active-title">
              <div>{{ item.title }}</div>
              <div>{{ item.desc }}</div>
            </div>
          </div>
          <div class="flex align-center justify-between active-info">
            <div class="flex align-center">
              <img :src="info.icon" />
              <div>
                <div>{{ info.name }}</div>
                <div>{{ info.language_list.version }}1.1.0</div>
              </div>
            </div>
            <div class="get-btn">{{ info.language_list.get }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="title">
      <h2>
        {{ info.language_list.new }}
        <i class="iconfont icon-fanye"></i>
      </h2>
      <div class="version">{{ info.language_list.version }}1.0.1</div>
    </div>
    <div class="info-text">
      {{ info.introduce }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.active {
  color: #000;
  .title {
    h2 {
      margin: 20px 0 8px 0;
    }
    div {
      color: var(--main-color);
      font-size: 12px;
    }
    .version {
      color: #666;
    }
    .iconfont {
      color: #000;
    }
  }
  .active-banner-box {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .active-banner {
    display: flex;
    flex-wrap: nowrap;
    height: 240px;
    width: fit-content;
    li {
      margin: 0 5px;
      width: 315px;
      height: 228px;
      border-radius: 6px;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);
      .active-item {
        width: 100%;
        height: 180px;
        position: relative;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 315px;
          border-radius: 6px 6px 0 0;
        }
        .active-title {
          position: absolute;
          bottom: 10px;
          left: 16px;
          color: #ffffff;
          font-size: 12px;
          width: 90%;
          & :last-child {
            font-size: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
          }
        }
      }
      .active-info {
        padding: 0 16px;
        img {
          width: 36px;
          height: 36px;
          margin-right: 8px;
        }
        .get-btn {
          color: var(--main-color);
          background-color: #e6e6e6;
          text-align: center;
          width: 64px;
          height: 23px;
          line-height: 23px;
          border-radius: 157px;
        }
      }
    }
  }
  .info-text {
    font-size: 12px;
    color: #333333;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 60px;
  }
}
</style>
